import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import axios from "axios";
import React, { useState } from "react";
import { baseUrl, mainBaseUrl } from "../App";
import "./Styles/AvatarSection.scss";
import Avatar from "@material-ui/core/Avatar";
import { useEffect } from "react";

const AvatarSection = ({ imgUrl }) => {
  const [fileopen, setFIleOpen] = React.useState(false);
  const [file, setFile] = useState("");
  const [imgBase64, setImageBase64] = useState("");
  const getImageData = () => {
    axios.get(imgUrl).then((response) => {
      setImageBase64(
        Buffer.from(response.data.image.data, "binary").toString("base64")
      );
    });
  };
  useEffect(() => {
    getImageData();
  }, []);
  const handleClickFileOpen = () => {
    setFIleOpen(true);
  };

  const handleFileClose = () => {
    setFIleOpen(false);
  };
  const updateAvatar = (e) => {
    var formData = new FormData();
    formData.append("avatar", file);
    axios
      .post(`${mainBaseUrl}/users/me/avatar`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
          "API-Key": baseUrl,
        },
      })
      .then(handleFileClose)
      .then(() => window.location.reload())
      .catch((e) => {
        alert(JSON.stringify(e.response.data));
      });
  };
  return (
    <div className="circle-avatar">
      <Avatar
        onClick={handleClickFileOpen}
        alt=""
        variant="circular"
        src={"data:image/jpeg;base64," + imgBase64}
        style={{ height: "120px", width: "120px" }}
      />

      <Dialog
        open={fileopen}
        onClose={handleFileClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Avatar Update</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            id="dpFile"
            label="Upload Image"
            type="file"
            variant="outlined"
            onChange={(e) => setFile(e.target.files[0])}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFileClose} color="primary">
            Cancel
          </Button>
          <Button onClick={updateAvatar} color="primary">
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AvatarSection;
